import { useTranslation } from "react-i18next";
import * as Yup from "yup";

export const SUPPORTED_FORMATS = "text/csv, text/plain";

export function useTrafficEmissionImportSchema() {
  const { t } = useTranslation();

  return Yup.object().shape({
    segmentFile: Yup.mixed()
      .nullable()
      .required(t("label.isRequiredValidation", { field: t("label.segmentFile") }))
      .test("fileType", "Unsupported file format", (value) => value && SUPPORTED_FORMATS.includes(value.type))
      .test("fileSize", "Your file is too big", (value) => value && value.size <= 262144000),
  });
}
